import Header from "./Header";
import Footer from "./Footer";
import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";

// === Base layout wrapper for all routes ===
// Includes header, dynamic content via <Outlet />, and footer.
export default function Layout() {
  const location = useLocation();
  const pathname = location.pathname || "";

  const isAuthPage =
    pathname === "/login" ||
    pathname === "/register" ||
    pathname === "/registered";

  const isFirmwareExplorer =
    pathname === "/firmware" || pathname.startsWith("/service-admin/firmware");

  // Hide the scrollbar visually on user-facing pages with dark backgrounds,
  // while keeping scrolling fully functional.
  const hideMainScrollbar = isAuthPage || isFirmwareExplorer;

  // === Scroll to top on route change ===
  useEffect(() => {
    const scrollToTop = () => {
      requestAnimationFrame(() => {
        window.scrollTo({ top: 0, behavior: "auto" });
      });
    };

    // Small delay ensures smooth transition (especially when routes are lazy-loaded)
    const timeout = setTimeout(scrollToTop, 50);

    return () => clearTimeout(timeout);
  }, [location.pathname]);

  return (
    <div className="app-layout">
      <Header />
      <main
        className={`main-wrapper${
          hideMainScrollbar ? " main-wrapper--hidden-scrollbar" : ""
        }`}
      >
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
